module.exports = __webpack_public_path__ + "img/Forming_stock.84db2fe3.svg";